import React, { useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Controller } from "swiper"
import 'swiper/swiper-bundle.min.css'
import cx from "classnames";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfFlatList = ({ url, swiper, active_slide, set_active_slide, total_pages, setSwiper, secondSwiper = null, }) => {
  useEffect(() => {
    if (swiper) {
      swiper.slideTo(active_slide - 1, 200)
    }
  }, [swiper, active_slide])
  return (
    <Document file={url}>
      <div className="GoogleSlidesFlatList">
        <Swiper
          // initialSlide={active_slide}
          slidesPerView={1}
          spaceBetween={50}
          onSwiper={setSwiper}
          modules={[Controller]}
          controller={{ control: secondSwiper }}
        >
          {[...Array(total_pages).keys()].map((el, index) =>
            <SwiperSlide>
              <div className="SwiperSlide">
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  className={cx(`page`, {
                    "active-slide": active_slide === index + 1,
                  })}
                  onClick={() => set_active_slide(index + 1)}
                />
              </div>
            </SwiperSlide>
          )}
        </Swiper>
      </div>
    </Document >
  )
};

export default PdfFlatList;
